import { ReadjustmentDto } from '@app/data/dtos/ptrab/irpf-readjustment/readjustment.dto';
import { IDataResponse } from '@app/entities/interfaces/data/data.interface';
import { Readjustment } from '@app/entities/models/ptrab/irpf-readjustment/readjustment.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapReadjustment: MapFromFn<ReadjustmentDto, Readjustment> = (value) =>
  Builder.forModel(Readjustment).companies(value.companies).isAllowed(value.is_allowed).build();

export const mapReadjustmentData: MapFromFn<IDataResponse<ReadjustmentDto>, Readjustment> = (value) =>
  mapReadjustment(value.data);
